/* eslint eqeqeq: 0 */
import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner, Card } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrashArrowUp,
  faCircleInfo,
} from "@fortawesome/free-solid-svg-icons";
import { faPenToSquare } from "@fortawesome/free-regular-svg-icons";
import axios from "axios";
import DataTable, { createTheme } from "react-data-table-component";
import Select from "react-select";
import Pengaturan from "./components/pengaturan";
function Billing() {
  //username (secret), profile baru, nominal, id_konsumen, id_bank
  const formData = new FormData();
  const dataHapus = new FormData();
  const [idEditCons, setIdEditCons] = useState("0");
  let idEdit = "0";
  const [dataEditCons, setDataEditCons] = useState([]);
  let dataEdit = [];
  const [disableButton, setDisableButton] = useState(false);
  const [show, setShow] = useState(false);
  const [showError, setShowError] = useState(false);
  const [judulError, setJudulError] = useState("");
  const [btnError, setBtnError] = useState("");
  const [isiForm, setIsiForm] = useState("");
  const [loading, setLoading] = useState(false);
  const [listSecret, setListSecret] = useState("");
  const [secretName, setSecretName] = useState("");
  const [pilihProfileBaru, setPilihProfileBaru] = useState("");
  const [profileBaru, setProfileBaru] = useState("");
  let profileLama;
  const [pilihBank, setPilihBank] = useState("");
  const [idBank, setIdBank] = useState("");
  const [caraBayar, setCaraBayar] = useState("");
  const [optCabayar, setOptCabayar] = useState("");
  const [idKonsumen, setIdKonsumen] = useState("");
  const [nominal, setNominal] = useState("");
  const [pesanError, setPesanError] = useState("");
  const [hanyaBayar, setHanyaBayar] = useState("");
  const [checkboxHanyaBayar, setCheckboxHanyaBayar] = useState("");
  const [petunjukHanyaBayar, setPetunjukHanyaBayar] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [psb, setPsb] = useState("");
  const [checkboxPsb, setCheckboxPsb] = useState("");
  const [petunjukPsb, setPetunjukPsb] = useState("");
  const [search, setSearch] = useState("");
  const [diCari, setDiCari] = useState("");
  const [posts, setPosts] = useState([]);
  const [fileBukti, setFileBukti] = useState([]);
  const [modalTitle, setModlaTitle] = useState("Tambah Data");
  let lokasi = Pengaturan["baseurl"] + "public/file/";
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const errorShow = () => setShowError(true);
  const errorClose = () => setShowError(false);
  let pesan_error = [];
  createTheme("myNewTheme", {
    text: {
      primary: "#268bd2",
      secondary: "#2aa198",
      fontSize: 2,
    },
  });
  /*
      &nbsp;&nbsp;<span onClick={()=>edit(row)} style={{fontSize: 20,cursor:'pointer'}} title="Edit"><FontAwesomeIcon icon={faPenToSquare} /></span>
    */
  const columns = [
    {
      cell: (row) => (
        <>
          <span
            onClick={() => detail(row)}
            style={{ fontSize: 20, cursor: "pointer" }}
            title="Detail"
          >
            <FontAwesomeIcon icon={faCircleInfo} />
          </span>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "25px",
    },
    {
      name: "User Name",
      selector: (row) => row.username,
      sortable: true,
      width: "170px",
    },
    {
      name: "Nama Konsumen",
      selector: (row) => row.nama,
      sortable: true,
    },
    {
      name: "Waktu",
      selector: (row) => row.waktu,
      sortable: true,
      width: "150px",
    },
    {
      name: "Profile",
      selector: (row) => row.profile,
      sortable: true,
    },
    {
      name: "Nominal",
      selector: (row) => row.nominal,
      sortable: true,
      width: "100px",
    },
    {
      cell: (row) => (
        <span
          onClick={() => hapus(row)}
          style={{ cursor: "pointer" }}
          title="Batalkan Pembayaran"
        >
          <span style={{ fontSize: 20 }}>
            <FontAwesomeIcon icon={faTrashArrowUp} />
          </span>
        </span>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "25px",
    },
  ];
  const edit = async (r) => {
    dataEdit = r;
    idEdit = r.id;
    setIdEditCons(idEdit);
    setDataEditCons(r);
    setModlaTitle("Edit Data " + r.nama);
    setDisableButton(false);
    setCheckboxHanyaBayar("");
    setPetunjukHanyaBayar("");
    setCheckboxPsb("");
    setPetunjukPsb("");
    setIsiForm("");
    setListSecret("");
    setPilihProfileBaru("");
    setPilihBank("");
    setOptCabayar("");
    setPilihBank("");
    //
    setPsb(r.psb);
    setHanyaBayar(r.bayarsaja);
    setProfileBaru(r.profile);
    setNominal(r.nominal.replace(".", ""));
    setSecretName(r.username);
    setCaraBayar(r.cara_bayar);
    if (r.cara_bayar == "cash") setIdBank("0");
    else setIdBank(r.id_bank);
    setIdKonsumen(r.id_konsumen);
    setStartDate(new Date());
    let isinya;
    handleShow();
    setIsiForm(
      <Form.Group className="mb-3" controlId="formIdKonsumen">
        <Form.Label>Pilih Konsumen</Form.Label>
        <div className="row justify-content-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      </Form.Group>
    );
    ambilSecret(r.id_konsumen);
    await axios
      .get(
        Pengaturan["urlApi"] +
          "billinggetkonsumen?router=" +
          localStorage.getItem("rtr")
      )
      .then((response) => {
        isinya = response.data;
        setIsiForm(
          <Form.Group className="mb-3" controlId="formIdKonsumen">
            <Form.Label>Pilih Konsumen</Form.Label>
            <Select
              onChange={(event) => ambilSecret(event.value)}
              options={isinya}
              defaultValue={{ value: r.id_konsumen, label: r.nama }}
            ></Select>
          </Form.Group>
        );
      });
    setCheckboxHanyaBayar(
      <Form.Check
        type="checkbox"
        id="hanyabayar"
        label="Hanya Bayar"
        onChange={(e) => bayarSaja(e.target.checked)}
        checked={r.bayarsaja}
      />
    );
    setCheckboxPsb(
      <Form.Check
        type="checkbox"
        id="hanyabayar"
        label="Pemasangan Baru"
        onChange={(e) => pasangBaru(e.target.checked)}
        checked={r.psb}
      />
    );
  };
  const detail = (r) => {
    setJudulError("Billing Detail");
    let pb = [];
    if (r.psb == "1") pb.push("Pasang Baru");
    if (r.bayarsaja == "1") pb.push("Bayar Saja");
    let ppb = pb.length >= 1 ? pb.join(", ") : "";
    setPesanError(
      <>
        <div className="row">
          <div className="col-md-12">
            <table className="table">
              <tr>
                <td>
                  Nama Konsumen
                  <br />
                  <strong>{r.nama}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  Nama Secret
                  <br />
                  <strong>{r.username}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  Waktu Bayar
                  <br />
                  <strong>{r.waktu}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  Profil
                  <br />
                  <strong>{r.profile}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  Nominal
                  <br />
                  <strong>{r.nominal}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  Cara Bayar
                  <br />
                  <strong>
                    {r.cara_bayar} {r.bank}
                  </strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>{ppb}</strong>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </>
    );
    setBtnError(
      <Button variant="danger" onClick={() => hapus(r)}>
        Hapus
      </Button>
    );
    errorShow();
  };
  const hapus = (r) => {
    let text_error;
    text_error =
      "Anda akan menghapus data Pembayaran<ul><li>Nama Konsumen : " +
      r.nama +
      "</li><li>Secret name : " +
      r.username +
      "</li><li>Profile : " +
      r.profile +
      "</li><li>Nominal : Rp. " +
      r.nominal +
      ",-</li></ul>";
    setPesanError(<div dangerouslySetInnerHTML={{ __html: text_error }}></div>);
    setJudulError("Hapus Pembayaran");
    setBtnError(
      <Button variant="danger" onClick={() => hapuskan(r)}>
        Hapus
      </Button>
    );
    errorShow();
  };
  const hapuskan = async (row) => {
    dataHapus.append("id", row.id);
    dataHapus.append("router", localStorage.getItem("rtr"));
    dataHapus.append("secretname", row.username);
    dataHapus.append("carabayar", row.cara_bayar);
    dataHapus.append("tabel_kasir", row.tabel_kasir);
    dataHapus.append("tabel_bank", row.tabel_bank);
    dataHapus.append("tabel_masuk", row.tabel_masuk);
    await axios
      .post(Pengaturan["urlApi"] + "billinghapus", dataHapus)
      .then((response) => {
        errorClose();
        ambilData();
      });
  };
  useEffect(() => {
    ambilData();
  }, [search]);
  const ambilData = async () => {
    const params = { cari: search, router: localStorage.getItem("rtr") };
    const headers = { "Access-Control-Allow-Origin": "*" };
    setLoading(true);
    await axios
      .get(Pengaturan["urlApi"] + "billinggetall", { params }, { headers })
      .then((response) => {
        setPosts(response.data);
      });
    setLoading(false);
  };
  const closeError = () => {
    pesan_error.length = 0;
    setShowError(false);
  };
  const changeCaraBayar = (cbr) => {
    setCaraBayar(cbr);
    if (cbr == "transfer") {
      let defVal = idEdit != "0" ? dataEdit.id_bank : "";
      setPilihBank(
        <Form.Group>
          <Form.Label>Pilih Bank</Form.Label>
          <select
            defaultValue={defVal}
            className="form-control"
            onChange={(event) => setIdBank(event.target.value)}
          >
            <option value="">Pilih Bank</option>
            <option value="1">BRI</option>
            <option value="2">Mandiri</option>
            <option value="5">BCA</option>
            <option value="6">BSI</option>
            <option value="7">BJB</option>
            <option value="8">Dana</option>
            <option value="9">OVO</option>
            <option value="10">LinkAja</option>
            <option value="11">BNI</option>
          </select>
        </Form.Group>
      );
    } else {
      setPilihBank("");
      setIdBank("");
    }
  };
  const pilihCaraBayar = () => {
    let devChe;
    if (idEdit != "0") {
      if (dataEdit.cara_bayar == "cash") {
        devChe = "cash";
      } else {
        devChe = "transfer";
        changeCaraBayar("transfer");
      }
    } else devChe = "";
    setOptCabayar(
      <Form.Group>
        <Form.Label>Cara Bayar</Form.Label>
        <select
          defaultValue={devChe}
          className="form-control"
          onChange={(event) => changeCaraBayar(event.target.value)}
        >
          <option value="">Pilih Cara Bayar</option>
          <option value="cash">Cash</option>
          <option value="transfer">Transfer</option>
        </select>
      </Form.Group>
    );
  };

  const bayarSaja = (checked) => {
    if (checked) {
      setHanyaBayar("1");
      setPetunjukHanyaBayar(
        "Hanya memproses pembayaran saja TIDAK mengubah profile maupun scheduler pada Mikrotik"
      );
    } else {
      setPetunjukHanyaBayar("");
      setHanyaBayar("0");
    }
  };
  const pasangBaru = (checked) => {
    if (checked) {
      setPsb("1");
      ambilProfile(profileLama);
      setPetunjukPsb(
        "Pastikan secret sudah dibuat di menu PPP -> Secret dan Secret sudah terhubung ke Database Konsumen"
      );
    } else {
      ambilProfile();
      setPetunjukPsb("");
      setPsb("0");
    }
  };

  const tambah = async () => {
    setIdEditCons("0");
    setDisableButton(false);
    setCheckboxHanyaBayar("");
    setPetunjukHanyaBayar("");
    setCheckboxPsb("");
    setPetunjukPsb("");
    setIsiForm("");
    setListSecret("");
    setPilihProfileBaru("");
    setPilihBank("");
    setOptCabayar("");
    setPilihBank("");
    //
    setPsb("0");
    setHanyaBayar("0");
    setProfileBaru("");
    setNominal("");
    setIdBank("");
    setSecretName("");
    setCaraBayar("");
    setIdKonsumen("");
    setStartDate(new Date());
    let isinya;
    handleShow();
    setIsiForm(
      <Form.Group className="mb-3" controlId="formIdKonsumen">
        <Form.Label>Pilih Konsumen</Form.Label>
        <div className="row justify-content-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      </Form.Group>
    );
    await axios
      .get(
        Pengaturan["urlApi"] +
          "billinggetkonsumen?router=" +
          localStorage.getItem("rtr")
      )
      .then((response) => {
        isinya = response.data;
        setIsiForm(
          <Form.Group className="mb-3" controlId="formIdKonsumen">
            <Form.Label>Pilih Konsumen</Form.Label>
            <Select options={isinya} onChange={getSlected}></Select>
          </Form.Group>
        );
      });
  };
  const getSlected = async (event) => {
    setIdKonsumen(event.value);
    setCheckboxHanyaBayar(
      <Form.Check
        type="checkbox"
        id="hanyabayar"
        label="Hanya Bayar"
        onChange={(e) => bayarSaja(e.target.checked)}
      />
    );
    setCheckboxPsb(
      <Form.Check
        type="checkbox"
        id="hanyabayar"
        label="Pemasangan Baru"
        onChange={(e) => pasangBaru(e.target.checked)}
      />
    );
    ambilSecret(event.value);
  };
  const ambilSecret = async (konsumen) => {
    let isiSecret;
    //setListSecret("Loading Secret Name...");
    setListSecret(
      <div className="row justify-content-center">
        <span>Loading Secret Name...</span>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
    await axios
      .get(
        Pengaturan["urlApi"] +
          "billinggetusername?id_konsumen=" +
          konsumen +
          "&router=" +
          localStorage.getItem("rtr")
      )
      .then((response) => {
        isiSecret = response.data;
        //console.log('get username', isiSecret['secretname'][0][3]);
        // {'secretname','profile dari mikrotik','waktuIsolir','profile dari tabel customer'}
      });
    if (isiSecret["secretname"].length == 1) {
      setSecretName(isiSecret["secretname"][0][0]);
      if (idEdit == "0") {
        ambilProfile(isiSecret["secretname"][0][3]);
        profileLama = isiSecret["secretname"][0][1];
        setProfileBaru(isiSecret["secretname"][0][3]);
      } else {
        ambilProfile(dataEdit.profile);
        profileLama = dataEdit.profile;
        setProfileBaru(dataEdit.profile);
      }
      setListSecret(
        <Form.Group>
          <Form.Label>
            Secret Name : <strong>{isiSecret["secretname"][0][0]}</strong>
            <br />
            Profile : <strong>{isiSecret["secretname"][0][1]}</strong>
            <br />
            Isolir : <strong>{isiSecret["secretname"][0][2]}</strong>
          </Form.Label>
        </Form.Group>
      );
    } else if (isiSecret["secretname"].length > 1) {
      const slct = isiSecret["secretname"].map((item, i) => {
        let prof =
          isiSecret["secretname"][i][1] == "profile-isolir"
            ? ""
            : " Isolir : " + isiSecret["secretname"][i][2];
        return (
          <option key={i} value={isiSecret["secretname"][i][0]}>
            {isiSecret["secretname"][i][0]} ({isiSecret["secretname"][i][1]}){" "}
            {prof}
          </option>
        );
      }, this);
      let terpilih = "";
      if (idEdit != "0") terpilih = dataEdit.username;
      setListSecret(
        <Form.Group>
          <Form.Label>Secret Name : {terpilih}</Form.Label>
          <select
            defaultValue={terpilih}
            className="form-control"
            onChange={(event) => pilihSecret(event.target.value)}
          >
            <option value="">Pilih Secret</option>
            {slct}
          </select>
        </Form.Group>
      );
    } else {
      setListSecret("Secret tidak ditemukan");
    }
  };
  const pilihSecret = (s) => {
    let x = s.split("#");
    setSecretName(x[0]);
    if (idEdit == "0") {
      ambilProfile(x[3]);
      profileLama = x[1];
      setProfileBaru(x[3]);
    } else {
      ambilProfile(dataEdit.profile);
      profileLama = dataEdit.profile;
      setProfileBaru(dataEdit.profile);
    }
  };
  let slct;
  const ambilProfile = async (pr) => {
    setPilihProfileBaru("");
    let listProfile, optProfile;
    await axios
      .get(
        Pengaturan["urlApi"] +
          "billinggetprofile?router=" +
          localStorage.getItem("rtr")
      )
      .then((response) => {
        listProfile = response.data;
        optProfile = listProfile.map((item, i) => {
          if (listProfile[i] == pr) slct = listProfile[i];
          return (
            <option key={i} value={listProfile[i]}>
              {listProfile[i]}
            </option>
          );
        }, this);
      });
    let nom;
    if (idEdit == "0") nom = "";
    else nom = dataEdit.nominal.replace(".", "");
    setPilihProfileBaru(
      <>
        <div className="row">
          <div className="col-md-6">
            <Form.Group>
              <Form.Label>Pilih Profile Baru {pr}</Form.Label>
              <select
                defaultValue={slct}
                className="form-control"
                onChange={(event) => setProfileBaru(event.target.value)}
              >
                <option value="">Pilih Profile Baru</option>
                {optProfile}
              </select>
            </Form.Group>
          </div>
          <div className="col-md-6">
            <Form.Group>
              <Form.Label>Nominal Bayar</Form.Label>
              <input
                defaultValue={nom}
                type="number"
                className="form-control"
                onChange={(event) => setNominal(event.target.value)}
              />
            </Form.Group>
          </div>
        </div>
        <hr />
      </>
    );
    pilihCaraBayar();
  };
  const simpanPembayaran = async () => {
    setShowError(false);
    if (idKonsumen.length < 2) pesan_error.push("Konsumen Belum dipilih");
    if (secretName.length < 2) pesan_error.push("Secret Belum dipilih");
    if (profileBaru.length < 2) pesan_error.push("Profile baru Belum dipilih");
    if (nominal.length < 2) pesan_error.push("Nominal pembayaran belum diisi");
    if (caraBayar.length < 2) pesan_error.push("Cara bayar Belum dipilih");
    if (idBank.length < 1 && caraBayar == "transfer")
      pesan_error.push("Bank Belum dipilih");
    if (pesan_error.length < 1) {
      formData.append("router", localStorage.getItem("rtr"));
      formData.append("profile", profileBaru);
      formData.append("nominal", nominal);
      formData.append("id_bank", idBank);
      formData.append("secretname", secretName);
      formData.append("carabayar", caraBayar);
      formData.append("id_konsumen", idKonsumen);
      formData.append("waktu", startDate);
      formData.append("bayarsaja", hanyaBayar);
      formData.append("psb", psb);
      formData.append("id_edit", idEditCons);
      let alamat;
      if (idEditCons == "0") {
        alamat = "billingsimpan";
      } else {
        alamat = "billingupdate";
        formData.append("tabel_kasir", dataEditCons.tabel_kasir);
        formData.append("tabel_masuk", dataEditCons.tabel_masuk);
        formData.append("tabel_keluar", dataEditCons.tabel_keluar);
        formData.append("tabel_bank", dataEditCons.tabel_bank);
      }
      setDisableButton(true);
      handleClose();
      setLoading(true);
      await axios
        .post(Pengaturan["urlApi"] + alamat, formData)
        .then((response) => {
          console.log(response.data);
          setDisableButton(false);
          ambilData();
        });
    } else {
      let text_error = "<ul><li>";
      text_error += pesan_error.join("</li><li>") + "</li></ul>";
      setPesanError(
        <div dangerouslySetInnerHTML={{ __html: text_error }}></div>
      );
      setJudulError("ERROR");
      setBtnError("");
      errorShow();
    }
  };

  const isi = () => {
    if (loading) {
      return (
        <div className="row justify-content-center">
          <br />
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      );
    } else {
      return (
        <div className="row justify-content-center">
          <div className="col-md-12">
            <DataTable
              className="table table-striped"
              columns={columns}
              data={posts}
              pagination
            />
          </div>
        </div>
      );
    }
  };
  return (
    <>
      <div className="row justify-content-md-center">
        <div className="col-md-6 text-right">
          <strong>Billing</strong>&nbsp;
          <Button
            onClick={tambah}
            className="btn btn-primary justify-content-end"
          >
            Tambah
          </Button>
        </div>
        <div className="col-md-6 justify-content-end">
          <input
            type="text"
            style={{ width: "70%" }}
            placeholder="Cari..."
            onChange={(e) => {
              if (e.target.value.length > 0) {
                setDiCari(e.target.value);
              } else {
                setSearch("");
              }
            }}
            onKeyDown={(event) => {
              if (event.key == "Enter") {
                setSearch(diCari);
              }
            }}
          />
          &nbsp;
          <button
            className="btn btn-primary btn-sm"
            onClick={() => {
              setSearch(diCari);
            }}
          >
            Cari
          </button>
        </div>
      </div>
      {isi()}
      <Modal
        show={showError}
        onHide={errorClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{judulError}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{pesanError}</Modal.Body>
        <Modal.Footer>
          {btnError}
          <Button variant="secondary" onClick={closeError}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="row">
              <div className="col-md-6">
                <Form.Group>
                  <Form.Label>Tanggal</Form.Label>
                  <DatePicker
                    className="form-control"
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    timeInputLabel="Time:"
                    dateFormat="dd/MM/yyyy HH:mm:ss"
                    showTimeInput
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">{isiForm}</div>
              <div className="col-md-6">{listSecret}</div>
              <div className="col-md-6">
                {checkboxHanyaBayar}
                <p
                  style={{
                    fontSize: 12,
                    lineHeight: "100%",
                    color: "GrayText",
                  }}
                >
                  {petunjukHanyaBayar}
                </p>
                {checkboxPsb}
                <p
                  style={{
                    fontSize: 12,
                    lineHeight: "100%",
                    color: "GrayText",
                  }}
                >
                  {petunjukPsb}
                </p>
              </div>
            </div>
            <hr />
            {pilihProfileBaru}
            <div className="row">
              <div className="col-md-4">{optCabayar}</div>
              <div className="col-md-3">{pilihBank}</div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={simpanPembayaran}
            disabled={disableButton}
          >
            Simpan
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default Billing;
